import { Component, OnInit } from '@angular/core';
import { GridBaseCase } from "../grid.base.case";
import { Platform } from '@ionic/angular';
import { HttpCustomerService } from '../../../../service/httpcustomer.service';
import { CommonService } from '../../../../service/common.service';
import { WebParameterContext } from '../../../../model/common';
import { ActivatedRoute, Router } from '@angular/router';
import { MessageclientService } from '../../../../service/messageclient.service';
import {HandleWebParameterContextBeforeDBRequest,HandleServerContextAfterDBRequest} from '../../../../bizlogic/servicesbll';

declare var app;
@Component({
  selector: 'app-mz-grid-list-news1',
  templateUrl: './mz-grid-list-news1.component.html',
  styleUrls: ['./mz-grid-list-news1.component.scss']
})
export class MzGridListNews1Component extends GridBaseCase implements OnInit {
  dataArrayList: Array<any> = [];
  elementIco: string;
  constructor(
    private http: HttpCustomerService,
    private activaRouter: ActivatedRoute,
    private router: Router,
    private platform: Platform,
    private msg: MessageclientService,
    private com: CommonService
  ) { super(); }

  LoadData() {
    let that = this;
    that.loading = false;
    that.apiObj['status'] = false;
    that.apiObj['msg'] = '';
    const PageName = that.activaRouter.snapshot.paramMap.get('ConfigName');
    let body = new WebParameterContext();
    that.elementIco = that.element.icon;
    if (that.element.selectItemList.gridViewConfigName) {
      body.ConfigName = that.element.selectItemList.gridViewConfigName;
    } else if (that.ConfigName) {
      body.ConfigName = that.ConfigName;
    }
    body.OpType = "query";
    body.ConfigType = "view";
    body.RowsPerPage = 2;
    body.Client.PageName = PageName;
    body.Client.ApiType = "Element";
    body.Client.Name = that.element.name;
    body.Client.ClientType = 2;
    if (that.platform.is("android")) {
      body.Client.ClientType = 0;
    } else if (that.platform.is("ios")) {
      body.Client.ClientType = 1;
    }
    body = HandleWebParameterContextBeforeDBRequest(body);
    if(!body.ResponseMessage.Success){
      that.msg.Alert(body.ResponseMessage.ErrorMessage);
      return;
    }
    that.http.post(app.DEFAULTURL, body).then(data => {
      that.dataArrayList = [];
      setTimeout(function () {
        that.apiObj['status'] = data.ResponseMessage.Success;
        that.apiObj['msg'] = data.ResponseMessage.ErrorMessage;
        that.loading = true;
      });
      data = HandleServerContextAfterDBRequest(body,data);
      if (data.ResponseMessage.Success) {
        data.Status.Datas.forEach(function (item) {
          let objfield = {};
          that.element.selectItemList.selectItem.forEach((element, index) => {
            if (element.bindingField) {
              objfield[element.bindingField] = item[element.field];
            }
            if (element.bindingField == 'date' && item[element.field]) {
              objfield[element.bindingField] = item[element.field].replace('00:00:00','');
            }
          });
          that.dataArrayList.push(objfield);
          // console.log(that.element.selectItemList.selectItem);
          // console.log(that.dataArrayList);
        });
      }
    }).catch(error => {
      that.apiObj['status'] = false;
      that.apiObj['msg'] = error.error.ResponseMessage.ErrorMessage;
      that.loading = true;
      console.log(error);
    })
  }
  EventLink(ev: any, parms: any) {
    let evs = ev.url || '';
    if (evs.trim() && parms) {
      if (evs.indexOf("http") > 0) {
        if(parms.title){
          this.com.goWebPage(evs,parms.title);
        }else{

        }
        console.log(evs, parms);
      } else {
        localStorage.setItem('element', JSON.stringify(ev));
        this.com.setHistoryUrl();
        // this.router.navigateByUrl(evs + "/" + ev.selectItemList.gridViewConfigName + "/" + parms.id);
        this.com.Go(evs + "/" + ev.selectItemList.gridViewConfigName + "/" + parms.id);
      }
    }
  }
     /**
   * 下拉刷新数据
   * @param event
   */
  doRefresh(event){
    this.LoadData();
    console.log("下拉刷新");
    event.target.complete();
  }
}
